// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canListDiscoveryResults } from "./check";

export function useCanListDiscoveryResults(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canListDiscoveryResults(withinScope);
  return canDoAction;
}
